import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      toast.error("Inserisci un'email valida.");
      return;
    }
  
    console.log("Dati inviati:", { email: trimmedEmail });
    try {
      const response = await axios.post("https://interventi.synology.me:5050/forgot-password", { email: trimmedEmail });
      console.log("Risposta dal backend:", response.data); // Debug della risposta
      toast.success("Email di recupero inviata con successo!", {
        autoClose: 3000, // Mostra il toast per 3 secondi
        onClose: () => navigate("/"), // Reindirizza solo dopo che il toast si chiude
      });
      setEmail("");
    } catch (error) {
      console.error("Errore nel recupero della password:", error);
      toast.error("Errore: " + (error.response?.data?.message || "Impossibile inviare l'email"), {
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="forgot-password-container">
      <h2>Recupera Password</h2>
      <form onSubmit={handleSubmit}>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Invia</button>
      </form>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default ForgotPassword;